import { library } from '@fortawesome/fontawesome-svg-core';
import { faAndroid } from '@fortawesome/free-brands-svg-icons/faAndroid';
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple';
import { faAppStoreIos } from '@fortawesome/free-brands-svg-icons/faAppStoreIos';
import { faWindows } from '@fortawesome/free-brands-svg-icons/faWindows';
import { faAddressBook } from '@fortawesome/pro-regular-svg-icons/faAddressBook';
import { faArrowAltToTop } from '@fortawesome/pro-regular-svg-icons/faArrowAltToTop';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import { faAsterisk } from '@fortawesome/pro-regular-svg-icons/faAsterisk';
import { faAt } from '@fortawesome/pro-regular-svg-icons/faAt';
import { faBackspace } from '@fortawesome/pro-regular-svg-icons/faBackspace';
import { faBarcode } from '@fortawesome/pro-regular-svg-icons/faBarcode';
import { faBarcodeAlt } from '@fortawesome/pro-regular-svg-icons/faBarcodeAlt';
import { faBarcodeRead } from '@fortawesome/pro-regular-svg-icons/faBarcodeRead';
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import { faBox } from '@fortawesome/pro-regular-svg-icons/faBox';
import { faBoxCheck } from '@fortawesome/pro-regular-svg-icons/faBoxCheck';
import { faBoxes } from '@fortawesome/pro-regular-svg-icons/faBoxes';
import { faBroadcastTower } from '@fortawesome/pro-regular-svg-icons/faBroadcastTower';
import { faBroom } from '@fortawesome/pro-regular-svg-icons/faBroom';
import { faBrowser } from '@fortawesome/pro-regular-svg-icons/faBrowser';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons/faBuilding';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faCarBuilding } from '@fortawesome/pro-regular-svg-icons/faCarBuilding';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faChevronDoubleDown } from '@fortawesome/pro-regular-svg-icons/faChevronDoubleDown';
import { faChevronDoubleUp } from '@fortawesome/pro-regular-svg-icons/faChevronDoubleUp';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronSquareDown } from '@fortawesome/pro-regular-svg-icons/faChevronSquareDown';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faCompass } from '@fortawesome/pro-regular-svg-icons/faCompass';
import { faCopyright } from '@fortawesome/pro-regular-svg-icons/faCopyright';
import { faDesktopAlt } from '@fortawesome/pro-regular-svg-icons/faDesktopAlt';
import { faDownload } from '@fortawesome/pro-regular-svg-icons/faDownload';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faEnvelopeOpen } from '@fortawesome/pro-regular-svg-icons/faEnvelopeOpen';
import { faExclamation } from '@fortawesome/pro-regular-svg-icons/faExclamation';
import { faExclamationSquare } from '@fortawesome/pro-regular-svg-icons/faExclamationSquare';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons/faExternalLink';
import { faFax } from '@fortawesome/pro-regular-svg-icons/faFax';
import { faFileCheck } from '@fortawesome/pro-regular-svg-icons/faFileCheck';
import { faFilePdf } from '@fortawesome/pro-regular-svg-icons/faFilePdf';
import { faFileSignature } from '@fortawesome/pro-regular-svg-icons/faFileSignature';
import { faFileTimes } from '@fortawesome/pro-regular-svg-icons/faFileTimes';
import { faFilter } from '@fortawesome/pro-regular-svg-icons/faFilter';
import { faFingerprint } from '@fortawesome/pro-regular-svg-icons/faFingerprint';
import { faHistory } from '@fortawesome/pro-regular-svg-icons/faHistory';
import { faHome } from '@fortawesome/pro-regular-svg-icons/faHome';
import { faIndustryAlt } from '@fortawesome/pro-regular-svg-icons/faIndustryAlt';
import { faInfo } from '@fortawesome/pro-regular-svg-icons/faInfo';
import { faInfoSquare } from '@fortawesome/pro-regular-svg-icons/faInfoSquare';
import { faLanguage } from '@fortawesome/pro-regular-svg-icons/faLanguage';
import { faLevelUp } from '@fortawesome/pro-regular-svg-icons/faLevelUp';
import { faList } from '@fortawesome/pro-regular-svg-icons/faList';
import { faLockAlt } from '@fortawesome/pro-regular-svg-icons/faLockAlt';
import { faMapMarker } from '@fortawesome/pro-regular-svg-icons/faMapMarker';
import { faMapSigns } from '@fortawesome/pro-regular-svg-icons/faMapSigns';
import { faMobileAndroid } from '@fortawesome/pro-regular-svg-icons/faMobileAndroid';
import { faNewspaper } from '@fortawesome/pro-regular-svg-icons/faNewspaper';
import { faPeopleCarry } from '@fortawesome/pro-regular-svg-icons/faPeopleCarry';
import { faPersonCarry } from '@fortawesome/pro-regular-svg-icons/faPersonCarry';
import { faPersonDolly } from '@fortawesome/pro-regular-svg-icons/faPersonDolly';
import { faPhone } from '@fortawesome/pro-regular-svg-icons/faPhone';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faQuestion } from '@fortawesome/pro-regular-svg-icons/faQuestion';
import { faScanner } from '@fortawesome/pro-regular-svg-icons/faScanner';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faSearchPlus } from '@fortawesome/pro-regular-svg-icons/faSearchPlus';
import { faSignIn } from '@fortawesome/pro-regular-svg-icons/faSignIn';
import { faSignOut } from '@fortawesome/pro-regular-svg-icons/faSignOut';
import { faSlidersH } from '@fortawesome/pro-regular-svg-icons/faSlidersH';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird';
import { faSyncAlt } from '@fortawesome/pro-regular-svg-icons/faSyncAlt';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt';
import { faTruck } from '@fortawesome/pro-regular-svg-icons/faTruck';
import { faTruckCouch } from '@fortawesome/pro-regular-svg-icons/faTruckCouch';
import { faTruckLoading } from '@fortawesome/pro-regular-svg-icons/faTruckLoading';
import { faTruckMoving } from '@fortawesome/pro-regular-svg-icons/faTruckMoving';
import { faTruckRamp } from '@fortawesome/pro-regular-svg-icons/faTruckRamp';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons/faUserPlus';
import { faWarehouseAlt } from '@fortawesome/pro-regular-svg-icons/faWarehouseAlt';
import { faWifiSlash } from '@fortawesome/pro-regular-svg-icons/faWifiSlash';
import { faWindowMaximize } from '@fortawesome/pro-regular-svg-icons/faWindowMaximize';
import { faWindowMinimize } from '@fortawesome/pro-regular-svg-icons/faWindowMinimize';
import { faWindowRestore } from '@fortawesome/pro-regular-svg-icons/faWindowRestore';
import { faClipboardCheck } from '@fortawesome/pro-regular-svg-icons/faClipboardCheck';
var FaLibraryHelpers = /** @class */ (function () {
    /**
     * Class constructor
     * @returns {void}
     * */
    function FaLibraryHelpers() {
    }
    /**Class initializer */
    FaLibraryHelpers.prototype.Initialize = function (iconLibrary) {
        this.AddIconsToLibrary(iconLibrary);
    };
    FaLibraryHelpers.prototype.AddIconsToLibrary = function (iconLibrary) {
        var iconIt = 0;
        //Icons necessary for the base APP
        library.add(faBackspace, faSignIn, faLanguage, faCompass, faCopyright, faTimes, faUser, faBars, faSignOut, faBrowser, faNewspaper, faPersonDolly, faPersonCarry, faCheck, faChevronSquareDown, faChevronDoubleDown, faChevronDoubleUp, faClock, faExclamationSquare, faChevronLeft, faChevronRight, faBoxCheck, faWifiSlash, faSyncAlt, faBarcode, faBarcodeAlt, faBarcodeRead, faSearch, faSearchPlus, faFilePdf, faBuilding, faWarehouseAlt, faIndustryAlt, faInfo, faInfoSquare, faFileSignature, faFileCheck, faHistory, faDownload, faArrowLeft, faFilter, faFingerprint, faTruck, faHome, faBroom, faDesktopAlt, faMobileAndroid, faArrowAltToTop, faFileTimes, faLevelUp, faEnvelopeOpen, faEnvelope, faTruckCouch, faQuestion, faPhone, faMapMarker, faAt, faFax, faMapSigns, faSlidersH, faLockAlt, faCalendar, faWindowRestore, faWindowMinimize, faWindowMaximize, faList, faTrashAlt, faSpinnerThird, faBox, faBoxes, faExclamation, faScanner, faTruckRamp, faPeopleCarry, faBroadcastTower, faTruckLoading, faTruckMoving, faPlus, faExternalLink, faAsterisk, faCarBuilding, faAddressBook, faUserPlus, faAndroid, faAppStoreIos, faWindows, faApple, faClipboardCheck);
        //Icons requested by the web site/app loading the base app
        for (iconIt = 0; iconIt < iconLibrary.length; iconIt++) {
            library.add(iconLibrary[iconIt]);
        }
    };
    return FaLibraryHelpers;
}());
var FaLibrary = new FaLibraryHelpers();
export default FaLibrary;
//# sourceMappingURL=FaLibrary.js.map